import React from 'react';
import { SectionDisclosuresProps, DisclosureGroupingsProps, DisclosureBannerProps } from 'libs/contentful/props';
import DisclosureGroupings from '../DisclosureGroupings/DisclosureGroupings';
import DisclosureBanner from '../DisclosureBanner/DisclosureBanner';

/**
 * Renders a disclosures section that can contain a DisclosureGroupings module
 * Specifically used when we need to render disclosure modules in one Ninetailed experience
 * @param props - Props including the disclosures content
 * @returns The rendered disclosures section component
 */
const SectionDisclosures = (props: SectionDisclosuresProps) => {
  if (!props) {
    return null;
  }

  const { disclosuresCollection } = props;

  if (!disclosuresCollection?.items?.length) {
    return null;
  }

  return (
    <>
      {disclosuresCollection.items.map((disclosure, index) => {
        if (!disclosure.__typename) {
          return null;
        }

        switch (disclosure.__typename) {
          case 'DisclosureGroupings':
            return <DisclosureGroupings key={`disclosure-${index}`} {...(disclosure as DisclosureGroupingsProps)} />;
          case 'DisclosureBanner':
            return <DisclosureBanner key={`disclosure-${index}`} {...(disclosure as DisclosureBannerProps)} />;
          default:
            console.warn(`SectionDisclosures: Unsupported disclosure type: ${disclosure.__typename}`);
            return null;
        }
      })}
    </>
  );
};

export default SectionDisclosures;
